import {
  RECEIVE_RESULTADO,
  CLEAN_RESULTADO,
  LOADING_RESULTADO,
} from "./resultadosActions";

const RESULTADO_INITIAL_STATE = {
  resultadoJBWeb: undefined,
  isLoading: false,
};

export default (state = RESULTADO_INITIAL_STATE, action) => {
  switch (action.type) {
    case CLEAN_RESULTADO:
      return {
        ...state,
        resultadoJBWeb: undefined,
      };
    case RECEIVE_RESULTADO:
      return {
        ...state,
        resultadoJBWeb: action.payload,
      };
    case LOADING_RESULTADO:
      return {
        ...state,
        isLoading: !state.isLoading,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/relatorios/resultadosReducer.js